import ApplicationController from '../../support/application_controller'

export default class extends ApplicationController {

  static targets = [
    'documentType',
    'pathologyTests'
  ]

  // ==== Controllers

  // ==== Actions

  toggleDocumentType() {
    const pathology = this.documentTypeTarget.value === 'pathology_result'

    this.pathologyTestsTarget.classList.toggle('u-hide', !pathology)
    if (!pathology) this.clearPathologyTests()
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  clearPathologyTests() {
    this.pathologyTestsTarget
      .querySelectorAll('input[type="checkbox"]')
      .forEach((checkbox) => { checkbox.checked = false })
  }

  // ==== Channels

}
